<script>
export default {
	name: 'ReportingSection',
	props: {
		title: {
			type: String,
			required: true,
		},
		subtitle: {
			type: String,
			default: '',
		},
		icon: {
			type: String,
			default: 'fish',
		},
		defaultOpened: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			opened: this.defaultOpened,
		}
	},
}
</script>

<template>
	<section class="reporting-section" :class="{ 'is-opened': opened }">
		<button type="button" class="reporting-section__head" :aria-expanded="String(opened)" @click="opened = !opened">
			<span class="reporting-section__icon">
				<svg v-if="icon === 'aqua'" width="38" height="30" viewBox="0 0 38 30" fill="none" stroke="currentColor" stroke-width="2">
					<rect x="1.5" y="1.5" width="35" height="27" rx="5" />
					<path d="M8 15c3.5-5.5 10-6.5 15.5-3.2L29 8.5v13l-5.5-3.3C18 21.5 11.5 20.5 8 15z" />
					<circle cx="13.5" cy="14" r="1.2" fill="currentColor" />
				</svg>
				<svg v-else width="40" height="26" viewBox="0 0 40 26" fill="none" stroke="currentColor" stroke-width="2">
					<path d="M3 13c5-8 15-10 23-5l9-5v20l-9-5c-8 5-18 3-23-5z" />
					<circle cx="10" cy="11.5" r="1.4" fill="currentColor" />
					<path d="M16 9c1.5 2.5 1.5 5.5 0 8" />
				</svg>
			</span>
			<span class="reporting-section__titles">
				<span class="reporting-section__title">{{ title }}</span>
				<span v-if="subtitle" class="reporting-section__subtitle">{{ subtitle }}</span>
			</span>
			<span class="reporting-section__chevron">
				<svg width="18" height="11" viewBox="0 0 18 11" fill="none" stroke="currentColor" stroke-width="2.2">
					<path d="M1 1l8 8 8-8" />
				</svg>
			</span>
		</button>
		<div v-show="opened" class="reporting-section__body">
			<slot />
		</div>
	</section>
</template>

<style scoped>
.reporting-section {
	margin-bottom: 20px;
	border: 1px solid #e3edf9;
	border-radius: 16px;
	background: #fff;
	box-shadow: 0 4px 18px rgba(21, 127, 238, 0.06);
	overflow: hidden;
}
.reporting-section__head {
	display: flex;
	align-items: center;
	gap: 18px;
	width: 100%;
	padding: 18px 24px;
	text-align: left;
	transition: background 0.2s;
}
.reporting-section.is-opened .reporting-section__head {
	background: linear-gradient(90deg, #eaf3fd 0%, #f4f8fe 100%);
}
.reporting-section__head:hover {
	background: #f4f8fe;
}
.reporting-section__icon {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-shrink: 0;
	width: 60px;
	height: 60px;
	border-radius: 14px;
	background: #f1f6fd;
	color: #157fee;
}
.reporting-section.is-opened .reporting-section__icon {
	background: transparent;
}
.reporting-section__titles {
	display: flex;
	flex: 1;
	flex-direction: column;
	gap: 4px;
}
.reporting-section__title {
	font-size: 20px;
	font-weight: 600;
	color: #151d48;
}
.reporting-section__subtitle {
	font-size: 14px;
	color: #6b7a90;
}
.reporting-section__chevron {
	color: #157fee;
	transition: transform 0.2s;
}
.reporting-section.is-opened .reporting-section__chevron {
	transform: rotate(180deg);
}
.reporting-section__body {
	padding: 12px 20px 20px;
}
</style>
